var _rect, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLogoPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 94,
    viewBox: "0 0 96 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 94,
    rx: 47,
    fill: "#C3D9FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1646_10398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.94 22.3396C58.5494 23.9066 61.9422 35.6625 54.657 39.1444L39.7408 38.2873C32.4267 35.5554 36.5158 23.9066 37.1252 22.3396C37.3146 21.8027 37.6705 21.3404 38.1409 21.0198C38.6114 20.6993 39.1718 20.5372 39.7408 20.5574C40.4871 19.195 41.582 18.0554 42.9135 17.2552C44.2449 16.455 45.7651 16.023 47.3183 16.0034C52.9659 15.8656 57.1156 19.9873 57.6575 21.7832L57.6593 21.7918C57.7704 21.9648 57.8644 22.1483 57.94 22.3396Z",
    fill: "#40352D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9607 42.7812V45.1823L63.714 49.4016C64.4677 49.6509 65.1114 50.1541 65.5354 50.8253C65.9594 51.4964 66.1374 52.2939 66.0389 53.0816L64.7682 63.2488C64.7423 63.4561 64.6416 63.6468 64.485 63.7851C64.3283 63.9233 64.1266 63.9996 63.9177 63.9996H31.1475C30.9386 63.9996 30.7369 63.9233 30.5803 63.7851C30.4236 63.6468 30.3229 63.4561 30.297 63.2488L29.0264 53.0839C28.928 52.2958 29.1064 51.4979 29.531 50.8267C29.9556 50.1554 30.6 49.6524 31.3543 49.4036L44.0811 45.2056L44.1041 42.7812H50.9607Z",
    fill: "#FFAB91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7141 49.4012L54.198 46.2529L54.3977 51.5631L47.5325 53.9715L40.6673 51.5631L40.8666 46.2652L31.3544 49.4033C30.6 49.6521 29.9554 50.1552 29.5308 50.8266C29.1062 51.498 28.928 52.296 29.0265 53.0843L30.2971 63.2492C30.323 63.4565 30.4237 63.6472 30.5803 63.7854C30.7369 63.9237 30.9387 64 31.1476 64H63.9174C64.1263 64 64.328 63.9237 64.4846 63.7854C64.6412 63.6472 64.742 63.4565 64.7679 63.2492L66.0387 53.0819C66.1374 52.2941 65.9595 51.4965 65.5356 50.8253C65.1116 50.154 64.4678 49.6507 63.7141 49.4012Z",
    fill: "#2B3A72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5326 52.7645L46.6756 49.2128L43.2473 47.5449L47.5326 52.7645Z",
    fill: "#8391BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5327 52.7645L48.3897 49.2128L51.818 47.5449L47.5327 52.7645Z",
    fill: "#8391BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.03 56.8677C55.025 52.7413 54.1572 46.9275 54.0423 46.2021L53.8041 46.1232L53.3106 45.9598L53.0813 45.9072L47.5323 52.7638L41.9833 45.9072L41.8847 45.9299L41.1168 46.1832L41.0203 46.215C40.8997 46.9795 40.0437 52.7584 41.0347 56.8677C41.7064 59.5579 43.0842 62.0201 45.0256 63.9998H50.039C51.9805 62.0201 53.3582 59.5579 54.03 56.8677Z",
    fill: "#C2D9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.623 33.1461C58.6214 32.2467 58.2666 31.3838 57.6349 30.7436C57.0033 30.1033 56.1454 29.7368 55.2461 29.723V29.7178H53.5319V36.5744H55.2461V36.5692C56.1454 36.5554 57.0033 36.1889 57.6349 35.5486C58.2666 34.9083 58.6214 34.0455 58.623 33.1461Z",
    fill: "#F99F84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8187 29.7178C38.9095 29.7178 38.0375 30.079 37.3946 30.7219C36.7516 31.3648 36.3904 32.2368 36.3904 33.1461C36.3904 34.0553 36.7516 34.9273 37.3946 35.5703C38.0375 36.2132 38.9095 36.5744 39.8187 36.5744H41.5329V29.7178H39.8187Z",
    fill: "#F99F84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9608 44.491V40.2119H44.1042V44.491C46.3063 45.3641 48.7586 45.3641 50.9608 44.491Z",
    fill: "#FFAB91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.819 29.7169C39.819 24.5101 40.5202 20.2891 47.5327 20.2891C54.5451 20.2891 55.2463 24.5101 55.2463 29.7169V35.7164C55.2463 37.7622 54.4336 39.7242 52.9871 41.1708C51.5405 42.6174 49.5785 43.4301 47.5327 43.4301C45.4869 43.4301 43.5249 42.6174 42.0783 41.1708C40.6317 39.7242 39.819 37.7622 39.819 35.7164V29.7169Z",
    fill: "#FFAB91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9757 21.4667C52.5438 19.9202 48.3436 19.3386 45.14 19.699C44.2534 19.6699 43.3748 19.8744 42.5923 20.2921C42.0916 20.464 41.6561 20.7861 41.3451 21.2146C41.2594 21.2975 41.1729 21.3761 41.0889 21.4667C38.7933 23.946 39.8187 29.716 39.8187 29.716C39.9461 28.5256 40.1737 27.348 40.4991 26.1959C40.6913 25.6763 41.0563 25.2386 41.5328 24.9562C42.4386 24.6868 43.2428 24.1518 43.8411 23.4203C44.9477 24.19 46.2064 24.7137 47.5323 24.9562C49.5248 25.1989 51.5394 25.1989 53.5319 24.9562C54.0084 25.2386 54.3734 25.6763 54.5656 26.1959C54.891 27.348 55.1186 28.5256 55.246 29.716C55.246 29.716 56.2714 23.946 53.9757 21.4667Z",
    fill: "#40352D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2928 52.893L46.6755 49.2128L44.0811 45.2051L41.2116 46.1521L44.2928 52.893Z",
    fill: "#97A9DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8588 46.1418L50.9611 45.1836L48.3898 49.2136L50.7725 52.8939L53.8588 46.1418Z",
    fill: "#97A9DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3948 45.7617L37.6855 47.315L35.9726 50.6038L38.6146 52.8565L37.3485 56.1557L45.0257 63.9999C42.9525 60.5782 41.8913 51.722 42.3948 45.7617Z",
    fill: "#415192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4503 52.8568L59.0924 50.6042L57.3738 47.3045L52.6689 45.748C53.1753 51.7085 52.1141 60.5759 50.0392 64.0003L57.7164 56.156L56.4503 52.8568Z",
    fill: "#415192"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_f_1646_10398)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 48,
    cy: 71,
    rx: 15,
    ry: 7,
    fill: "#7E7D99",
    fillOpacity: 0.77
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1646_10398",
    x: 19,
    y: 50,
    width: 58,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_1646_10398"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1646_10398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(24 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogoPerson);
export default __webpack_public_path__ + "static/media/icon-logo-person.291d5951212ded9fe0314259c1901847.svg";
export { ForwardRef as ReactComponent };